import script from "./FormInputDuration.vue?vue&type=script&setup=true&lang=js"
export * from "./FormInputDuration.vue?vue&type=script&setup=true&lang=js"

import "./FormInputDuration.vue?vue&type=style&index=0&id=4dc8b5eb&lang=css"

const __exports__ = script;

export default __exports__